import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { RECOGNITIONS_TAB } from '@hero/constants';
import { ROUTE_PATHS } from '@hero/routes';

import * as S from './style';

export function SendGiftWithContactSendEmail() {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();
  const navigate = useNavigate();

  return (
    <S.Wrapper>
      <Image name="confirmationWithContact" alt="Donation" height={220} />
      <S.TitleWrapper>
        <Typography variant="subtitle4Bold">{t('yourGiftsOnTheirWay')}</Typography>
        <Typography>{t('yourGiftEmailWillArrive')}</Typography>
      </S.TitleWrapper>
      <S.Footer>
        <Typography variant="body2" color="fg" emphasis="weaker">
          <Trans
            i18nKey="orderConfirmationMessage"
            components={{
              a1: (
                <S.SupportLink
                  href={`${ROUTE_PATHS.DASHBOARD}${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${
                    RECOGNITIONS_TAB.order
                  }`}
                />
              ),
              a2: (
                <S.SupportLink
                  href={`${ROUTE_PATHS.DASHBOARD}${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${
                    RECOGNITIONS_TAB.analytics
                  }`}
                />
              )
            }}
          />
        </Typography>
        <S.ButtonGroup>
          <Button
            onClick={() => {
              navigate(
                `${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${RECOGNITIONS_TAB.order}`
              );
            }}
            variant="outlined"
          >
            {t('seeDetails')}
          </Button>
          <Button
            onClick={() => {
              navigate(
                `${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${RECOGNITIONS_TAB.analytics}`
              );
            }}
          >
            {t('seeAnalytics')}
          </Button>
        </S.ButtonGroup>
      </S.Footer>
    </S.Wrapper>
  );
}
